import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var CountLimiter = /*#__PURE__*/function () {
  function CountLimiter(maxItemsPerFrame) {
    _classCallCheck(this, CountLimiter);
    this.maxItemsPerFrame = maxItemsPerFrame;
    this.itemsLeft = 0;
  }
  _createClass(CountLimiter, [{
    key: "beginFrame",
    value: function beginFrame() {
      this.itemsLeft = this.maxItemsPerFrame;
    }
  }, {
    key: "allowedToUpload",
    value: function allowedToUpload() {
      return this.itemsLeft-- > 0;
    }
  }]);
  return CountLimiter;
}();
export { CountLimiter };